import React from 'react'
import Subheader from '../../../component/Subheader'
import OtherRoom from '../../RoomDetail/OtherRoom';
import RoomBanner from '../../RoomDetail/RoomBanner';
import RoomQuote from '../../RoomDetail/RoomQuote';
import RoomCount from '../../RoomDetail/RoomCount';
import RoomGallery from '../../RoomDetail/RoomGallery';
import RoomEquipment from '../../RoomDetail/RoomEquipment';
import RoomBook from '../../RoomDetail/RoomBook';

export default function CorbettPremium() {
    const heading = "Premium Cottages";

    const subheadData = {
        heading: (
                    <>
                    <span className="sr-only">Corbett Room</span> {heading}
                    </>
                ),
        breadcrumb: [
            {
                slug: "/resort-de-coracao-corbett/room-listing",
                name: (
                        <>
                        <span className="sr-only">{heading}</span> Rooms
                        </>
                    ),
            },
            {
                slug: "",
                name: "Premium Cottages",
            },
        ]
    }

    const roomBanner = {
        image: "/image/corbett-premium-cottages-room-detail.webp",
    };

    const roomQuote = {
        content: "A Soak in the Wild The Premium Cottages are designed for those who love a slow pace. After a day of exploring the Corbett trails, you can retreat to your private bathtub for a long, quiet soak. The interiors are cozy and grounded, using natural materials that make you feel connected to the forest while keeping you wrapped in comfort.",
    };

    const roomCount = {
        bedroom: "1",
        bedsize: "1",
        area: "41",
        bathroom: "1",
        guest: "3",
        balcony: "1"
    };

    const roomGallery = [
        { image: "/image/corbett-premium-room-gallery-1.webp" },
        { image: "/image/corbett-premium-room-gallery-2.webp" },
        { image: "/image/corbett-premium-room-gallery-3.webp" },
        { image: "/image/corbett-premium-room-gallery-4.webp" },
        { image: "/image/corbett-premium-room-gallery-5.webp" },
        { image: "/image/corbett-premium-room-gallery-6.webp" },
    ];

    const roomEquipment = {
        description: "Enjoy a refined room experience with inviting spaces, contemporary facilities, and thoughtful touches throughout your stay.",
        equipment: [
        [
            "Full-sized Bathtub for relaxing soaks",
            "Evening Turndown Service to keep things tidy",
            "Coffee & Tea Maker for early safari mornings",
            "Mini-Fridge for snacks and refreshments",
        ],

        [
            "Large LED Screen with Satellite channels",
            "Dedicated Writing Desk with power points",
            "Pocketed Spring Mattress for back support",
            "Digital Safety Locker for your valuables",
        ],
        [
            "Hydropneumatic shower system",
            "Plush Cotton Towels and Linens",
            "One-touch Speaker Phone for service",
            "Complimentary High-speed Wi-Fi",
        ]
    ]
    };

    const roomBook = {
        location: "Corbett",
        title: "Premium Cottages",
        desc: "Relax into the natural charm of the Premium Cottages at De Coracao Corbett, thoughtfully designed for peaceful escapes. With a private bathtub, cozy interiors, and modern amenities, they offer a comfortable retreat where you can unwind after exploring the wilderness.",
        details: [
            "1 King Size Bed + 1 Extra Mattress Allowed",
            "Up to 3 Guests",
            "41 sq.mt"
        ],
        enquireLink: "/contact-us",
        bookLink: "https://www.swiftbook.io/inst/#home?propertyId=701Mn5Ca4GiFpRG7wK2385ZRnQ8BcTaRjrMkE4mjc5NQ==&JDRN=Y"
    };


    const otherRoom = {
        slides: [
            {
                title: 'Club Cottages',
                bg: '/image/corbett-other-room-1.webp',
                slug: '/resort-de-coracao-corbett/club-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress ",
                    "Up to 4 Guests",
                    "42 sq.mt",
                ],
            },

            {
                title: 'Luxury Cottages',
                bg: '/image/corbett-other-room-3.webp',
                slug: '/resort-de-coracao-corbett/luxury-cottages',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "41 sq.mt",
                ],
            },

            {
                title: 'Luxury Room',
                bg: '/image/corbett-other-room-4.webp',
                slug: '/resort-de-coracao-corbett/luxury-room',
                details: [
                    "1 King Size Bed + 1 Extra Mattress Allowed",
                    "Up to 3 Guests",
                    "37 sq.mt",
                ],
            },

            {
                title: 'Family Cottages',
                bg: '/image/corbett-other-room-5.webp',
                slug: '/resort-de-coracao-corbett/family-cottages',
                details: [
                    "2 King Size Beds + 1 Extra Mattress Allowed",
                    "Up to 6 Guests",
                    "67 sq.mt",
                ],
            },
        ],

        allRoom: { link: "/resort-de-coracao-corbett/room-listing" }
    }

    return (
        <>  
            <Subheader subheadData={subheadData} />
            <RoomBanner roomBanner={roomBanner} />
            <RoomQuote roomQuote={roomQuote} />
            <RoomCount roomCount={roomCount} />
            <RoomGallery roomGallery={roomGallery} />
            <RoomEquipment roomEquipment={roomEquipment} />
            <RoomBook roomBook={roomBook} />
            <OtherRoom otherRoom={otherRoom} roomTitle={`${roomBook.location} ${subheadData.heading}`}/>
        </>
    )
}
